import { ref, onMounted, onUnmounted } from "vue"
import { replayQueuedFunctionCalls } from "@/lib/offlineQueue"

const online = ref(navigator.onLine)
let started = false
let refCount = 0

export function useOnlineStatus() {
  const goOnline = async () => {
    online.value = true
    await replayQueuedFunctionCalls()
  }
  const goOffline = () => {
    online.value = false
  }

  onMounted(async () => {
    refCount++

    if (!started) {
      window.addEventListener("online", goOnline)
      window.addEventListener("offline", goOffline)
      started = true
      if (online.value) await replayQueuedFunctionCalls()
    }
  })

  onUnmounted(() => {
    refCount--

    // Only remove listeners when no more components are using this composable
    if (refCount === 0 && started) {
      window.removeEventListener("online", goOnline)
      window.removeEventListener("offline", goOffline)
      started = false
    }
  })

  return { online }
}
